import { VIEWER_ID, VIEWER_TYPE } from 'relay-runtime'

import { phoneNumberParticipantClientId } from '@odyssey/features/phone-numbers/phoneNumberParticipantClientId'

// Payload types whose `id` is actually the entity they acted on, not their own —
// keying by it would merge the payload onto that entity's record.
const ENTITY_ID_MUTATION_PAYLOADS = new Set([
  'WebhookEventCreateSuccess',
  'WebhookRetrySuccess',
])

const PHONE_PARTICIPANT_TYPES = new Set([
  'AnonymousParticipant',
  'ContactParticipant',
  'PhoneChannelParticipant',
])

/**
 * Custom Relay `getDataID`: mostly defers to Relay's default (`fieldValue.id`),
 * with three overrides — dropping mutation payloads that reuse an acted-on
 * entity's id, keying phone participants by their number, and normalizing the
 * singleton Viewer record.
 */
export function getDataID(
  fieldValue: Record<string, unknown>,
  typeName: string,
): string | undefined {
  if (ENTITY_ID_MUTATION_PAYLOADS.has(typeName)) {
    return undefined
  }

  if (PHONE_PARTICIPANT_TYPES.has(typeName)) {
    const phoneNumber = fieldValue.phoneNumber as { id?: string } | null | undefined

    return phoneNumber?.id == null
      ? undefined
      : phoneNumberParticipantClientId(phoneNumber.id)
  }

  // Preserve Relay's default behaviour for every other type, including the
  // special-cased singleton Viewer record.
  if (typeName === VIEWER_TYPE) {
    return fieldValue.id == null ? VIEWER_ID : (fieldValue.id as string)
  }

  return fieldValue.id as string | undefined
}
